import { useEffect, useState } from "react";
import { useEvent } from "@/context/AppContext";

const HOLD_MS = 5000;

// Colleagues typing (site only, the client never sees it): conversation id -> { name, last_reply_at, until }.
export function useStaffTyping(convId = null) {
  const [map, setMap] = useState({});
  useEvent("STAFF_TYPING", (d) => { if (!convId || d.conversation_id === convId) setMap((p) => ({ ...p, [d.conversation_id]: { ...d, until: Date.now() + HOLD_MS } })); });
  useEffect(() => {
    const t = setInterval(() => setMap((p) => { const n = Object.fromEntries(Object.entries(p).filter(([, v]) => v.until > Date.now())); return Object.keys(n).length === Object.keys(p).length ? p : n; }), 1000);
    return () => clearInterval(t);
  }, []);
  return convId ? map[convId] || null : map;
}
